import Vue from 'vue'
import _ from 'lodash'
import io from 'socket.io-client'
import {restapi, sockapi} from './http'

export default new Vue({
    methods: {
      setSession (user, skipStore) {
        restapi.defaults.headers.common['token'] = user.token
        sockapi.defaults.headers.common['token'] = user.token
        this.user = user
        if (!skipStore) sessionStorage.setItem('SESSION', JSON.stringify(user))
  
        console.log('set session')
        let query = {token: user.token}
        // this.socket = io(process.env.VUE_APP_SOCKET_HOST + 'physician', {query})
        this.socket = io('/physician', {query})
        this.socket.on('connect', this.onOpenHandler.bind(this))
        this.socket.on('json', this.onMessageHandler.bind(this))
        this.socket.on('error', this.onErrorHandler.bind(this))
        this.socket.on('connect_error', this.onErrorHandler.bind(this))

        // const serveruri = process.env.developement ? 'ws://localhost:8080' : 'wss://t-vsm.com'
        // this.signaling = new WebSocket(`${serveruri}/ws.signaling?token=${token}`)
        // this.signaling.onopen = this.onOpenHandler.bind(this)
        // this.signaling.onerror = this.onErrorHandler.bind(this)
        // this.signaling.onmessage = this.onMessageHandler.bind(this)
        // this.signaling.onclose = this.onCloseHandler.bind(this)
      },
      loadSessionData () {
        try {
          let str = sessionStorage.getItem('SESSION')
          if (!str) return false
          let json = JSON.parse(str)
  
          this.setSession(json, true)
          return true
        }
        catch (error) {
          console.error(error)
          sessionStorage.removeItem('SESSION')
          return false
        }
      },
      releaseSession () {
        restapi.defaults.headers.common['token'] = ''
        delete restapi.defaults.headers.common['token']
        sockapi.defaults.headers.common['token'] = ''
        delete sockapi.defaults.headers.common['token']
        sessionStorage.removeItem('SESSION')
        this.user = null
  
        if (this.socket) this.socket.close()
        else console.error('No Socket Instance')
      },
  
      send (cmd, data, target) {
        // this.signaling.send(JSON.stringify({cmd, data, target}))
        // this.socket.emit('json', JSON.stringify({cmd, data, target}))
        this.socket.emit('json', {cmd, data, target})
      },
      onOpenHandler () {
        this.sopen = true
        this.$emit('ws.open')
      },
      onErrorHandler (err) {
        console.error(err)
        switch (err) {
          case 'unauthorized': {
            // TODO: 에러 핸들링
            console.error(err)
            break;
          }
          // default: {

          // }
        }
        this.releaseSession()
      },
      onMessageHandler (json) {
        // this.$emit('ws.message', evt)
        // let json = JSON.parse(evt.data)
        switch (json.cmd) {
          case 'me': {
            console.log(json)
            break;
          }
          case 'devices': {
            this.devices = json.devices
            break;
          }
          case 'user-connect': {
            let user = null
            if (json.data.role === 'PA') user = _.find(this.devices, {_id: json.data._id})
            else user = _.find(this.physicians, {_id: json.data._id})
  
            if (!user) return;
            user.connect = json.data.connectedTime
            break;
          }
          case 'user-disconnect': {
            let user = null
            if (json.data.role === 'PA') user = _.find(this.devices, {_id: json.data._id})
            else user = _.find(this.physicians, {_id: json.data._id})
  
            if (!user) return;
            user.connect = null
            break;
          }
          case 'tvsmdata': {
            let {topic, data} = json
            if (this.onsubs[topic]) {
              this.onsubs[topic](data)
            }
            break;
          }
          case 'ring':
          case 'hangout': {
            this.$emit(json.cmd, json.data)
            break;
          }
          case 'candidate':
          case 'sdp': {
            this.$emit(json.cmd, json.data)
            break;
          }
          case 'device-change': {
            let {serial, state} = json.device
            let dev = _.find(this.devices, {serial_name: serial})
            if (dev && dev.device_status != state.alive) {
              dev.device_status = state.alive
              this.$emit(json.cmd, dev)
            }
            break;
          }
          case 'pong': {
            console.log('pong')
            break;
          }
          case 'callerror': {
            this.$emit(json.cmd, json.data)
            break;
          }
          default: {
            console.log(json)
          }
        }
      },
      onCloseHandler () {
        this.sopen = false
        clearTimeout(this.pingTimer)
      },
      sendPing () {
        this.send('ping')
        this.pingTimer = setTimeout(this.sendPing.bind(this), 5 * 1000)
      },

      subscribe (topic, handler) {
        console.log('subscribe: ' + topic)
        this.send('subs-device', topic)
        this.onsubs[topic] = handler
      },
      unsubscribe (topic) {
        this.send('unsubs-device', topic)
        if (this.onsubs[topic]) delete this.onsubs[topic]
      }
    },
    created () {
      this.loadSessionData()
    },
    data () {
      return {
        user: null,
        socket: null,
        signaling: null,
        sopen: false,
        devices: [],
        physicians: [],
        pingTimer: null,
        onsubs: {}
      }
    }
})